import React from "react"
import CalendarTutorial from "../../components/calendar-tutorial"

const tutorial = {
  quickAnswer: {
    question: "When are proposed events saved?",
    answer:
      "A proposal is a preview. Check its dates, times and durations, correct the request if needed, then select Add to calendar. Saving events and publishing a shared calendar are separate actions.",
  },
  title: "Generate Calendar Events with AI",
  description:
    "Use Magic Generate to turn a plain-language schedule into calendar events, review the results, and add them to your week.",
  intro:
    "Describe the events you want in everyday language. This short walkthrough shows how to create a small schedule with Magic Generate and check it before adding it to your calendar.",
  rows: [
    ["Monday", "9:00 am", "Reading", "30 min"],
    ["Tuesday", "10:00 am", "Maths", "45 min"],
    ["Friday", "2:00 pm", "Assembly", "30 min"],
  ],
  prompt:
    "For the week starting Monday [YYYY-MM-DD], create these events:\nMonday 9am Reading for 30 minutes\nTuesday 10am Maths for 45 minutes\nFriday 2pm Assembly for 30 minutes",
  steps: [
    {
      title: "Example: correct a proposal before saving",
      paragraphs: [
        "Suppose you request Reading on Monday at 9am for 30 minutes, but the proposal shows 60 minutes. Do not add that proposal. Clarify the request: ‘Reading should last 30 minutes, from 9:00 to 9:30.’ Review the new proposal before selecting Add to calendar.",
        "This is an illustrative review example, not a transcript or a guarantee of a particular AI response. Check the actual date and every event in your own proposal.",
      ],
    },
    {
      title: "1. Choose the calendar and week",
      paragraphs: [
        "Open School Calendar and choose New blank calendar, or open the calendar you want to update. Check its title and navigate to your chosen week.",
        "Use the example above or replace the activities with your own. Replace [YYYY-MM-DD] with the Monday date for that week.",
      ],
    },
    {
      title: "2. Send a clear request",
      paragraphs: [
        "Open Magic Generate and paste your request. Include the day, start time, activity name, and duration for each event.",
        "If you have already added an event manually, leave it out of the request to avoid adding it twice.",
      ],
    },
    {
      title: "3. Review the proposed events",
      paragraphs: [
        "Check every date, start time, activity name, and duration. Make sure the dates belong to the week you intended and that the events fit around your existing plans.",
        "If the proposal does not match your request, clarify it in the chat and review the revised result before proceeding.",
      ],
    },
    {
      title: "4. Add and check the schedule",
      paragraphs: [
        "When the proposal is correct, select Add to calendar. Inspect the calendar and open any event that needs a detail or time adjustment.",
        "If you want families to view the plan, follow the publish and share guide next. Adding events does not itself publish the calendar.",
      ],
    },
  ],
  cta: "Try Magic Generate",
  relatedUrl: "/how-to-guides/publish-share-calendar/",
  relatedTitle: "Publish and Share Your Calendar",
}

export default function GuidePage() {
  return <CalendarTutorial {...tutorial} />
}
